import RyddmLogo from './ryddm_logo.svg'

export const logos = {
  RyddmLogo,
}
